import React from "react";

const SvgPravnickaOsoba = props => (
  <svg viewBox="0 0 214.94 208" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <g data-name="Pravnicka osoba">
          <path
            data-name="&lt;\u0158ez&gt;"
            fill="none"
            d="M0 0h214.94v208H0z"
          />
          <path d="M129.19 64.75c-3 0-5.88 2.65-5.88 6.6v110.38c0 4 2.85 6.56 5.88 6.56h57c3 0 5.91-2.61 5.91-6.56V71.35c0-3.95-2.88-6.6-5.91-6.6zm8.62 17.88h40a4.78 4.78 0 110 9.55h-40a4.78 4.78 0 110-9.55zm0 25.43h40a4.78 4.78 0 110 9.55h-40a4.78 4.78 0 110-9.55zm0 25.46h40a4.78 4.78 0 110 9.55h-40a4.78 4.78 0 110-9.55zm0 25.43h40a4.78 4.78 0 110 9.55h-40a4.78 4.78 0 110-9.55zM31.14 7.14A5.64 5.64 0 0025.58 13v174.13a5.63 5.63 0 005.56 5.87h82.08a5.62 5.62 0 005.55-5.85V13a5.63 5.63 0 00-5.55-5.85zm9.31 19.47h63.46a4.72 4.72 0 014.74 4.71v.12a4.73 4.73 0 01-4.74 4.72H40.45a4.72 4.72 0 01-4.72-4.72v-.12a4.71 4.71 0 014.72-4.71zm0 33h63.46a4.72 4.72 0 014.74 4.71v.09a4.76 4.76 0 01-4.74 4.75H40.45a4.74 4.74 0 01-4.72-4.75v-.09a4.71 4.71 0 014.72-4.67zm0 33h63.46a4.73 4.73 0 014.74 4.72v.12a4.72 4.72 0 01-4.74 4.71H40.45a4.71 4.71 0 01-4.72-4.71v-.12a4.71 4.71 0 014.72-4.67zM58 144.15h28.36a3 3 0 012.92 3.16v35.28H55.07v-35.28a3 3 0 012.93-3.16z" />
          <path d="M16 183.22a4.89 4.89 0 000 9.78h185.66a4.89 4.89 0 000-9.77z" />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgPravnickaOsoba;
